import FieldWrapper from '~/utils/formik/FieldWrapper'
import FastFieldWrapper from '~/utils/formik/FastFieldWrapper'

import Dropdown from './Dropdown'
import Input from './Input'
import SelectButton from './SelectButton'
import Checkbox from './Checkbox'
import TextEditor from './TextEditor'
import ShortTextEditor from './ShortTextEditor'
import Switch from './Switch'
import DayPicker from './DayPicker'
import TimePicker from './TimePicker'
import TimeSelect from './TimeSelect'
import TimeRange from './TimeRange'
import SingleAsyncSelect from './SingleAsyncSelect'
import MultipleAsyncSelect from './MultipleAsyncSelect'
import AsyncSelect from './AsyncSelect'
import Select from './Select'
import StarSelect from './StarSelect'
import RadioButtonDetail from './RadioButtonDetail'
import CategoryList from './CategoryList'
import SelectionSearch from './SelectionSearch'
import SelectCenter from './SelectCenter'
import Button from './Button'
import InputTag from './InputTag'
import NumberInput from './NumberInput'
import TooltipWrapper from './TooltipWrapper'
import GallerySinglePicker from './GallerySinglePicker'
import ErrorText from './ErrorText'
import DiscountInput from './DiscountInput'
import DateTimeInput from './DateTimeInput'
import AmountWUnitInput from './AmountWUnitInput'

export const Field = {
  Input: FieldWrapper(Input),
  NumberInput: FieldWrapper(NumberInput),
  Dropdown: FieldWrapper(Dropdown),
  SelectButton: FieldWrapper(SelectButton),
  Checkbox: FieldWrapper(Checkbox),
  Switch: FieldWrapper(Switch),
  DayPicker: FieldWrapper(DayPicker),
  TimePicker: FieldWrapper(TimePicker),
  TimeSelect: FieldWrapper(TimeSelect),
  TimeRange: FieldWrapper(TimeRange),
  TextEditor: FieldWrapper(TextEditor),
  ShortTextEditor: FieldWrapper(ShortTextEditor),
  SingleAsyncSelect: FieldWrapper(SingleAsyncSelect),
  MultipleAsyncSelect: FieldWrapper(MultipleAsyncSelect),
  AsyncSelect: FieldWrapper(AsyncSelect),
  Select: FieldWrapper(Select),
  RadioButtonDetail: FieldWrapper(RadioButtonDetail),
  CategoryList: FieldWrapper(CategoryList),
  SelectionSearch: FieldWrapper(SelectionSearch),
  SelectCenter: FieldWrapper(SelectCenter),
  Button: FieldWrapper(Button),
  StarSelect: FieldWrapper(StarSelect),
  InputTag: FieldWrapper(InputTag),
  TooltipWrapper: FieldWrapper(TooltipWrapper),
  GallerySinglePicker: FieldWrapper(GallerySinglePicker),
  ErrorText: FieldWrapper(ErrorText),
  DiscountInput: FieldWrapper(DiscountInput),
  DateTimeInput: FieldWrapper(DateTimeInput),
  AmountWUnitInput: FieldWrapper(AmountWUnitInput),
}

export const FastField = {
  Input: FastFieldWrapper(Input),
  NumberInput: FastFieldWrapper(NumberInput),
  Dropdown: FastFieldWrapper(Dropdown),
  SelectButton: FastFieldWrapper(SelectButton),
  Checkbox: FastFieldWrapper(Checkbox),
  Switch: FastFieldWrapper(Switch),
  DayPicker: FastFieldWrapper(DayPicker),
  TimePicker: FastFieldWrapper(TimePicker),
  TimeSelect: FastFieldWrapper(TimeSelect),
  TimeRange: FastFieldWrapper(TimeRange),
  TextEditor: FastFieldWrapper(TextEditor),
  ShortTextEditor: FastFieldWrapper(ShortTextEditor),
  SingleAsyncSelect: FastFieldWrapper(SingleAsyncSelect),
  MultipleAsyncSelect: FastFieldWrapper(MultipleAsyncSelect),
  AsyncSelect: FastFieldWrapper(AsyncSelect),
  Select: FastFieldWrapper(Select),
  RadioButtonDetail: FastFieldWrapper(RadioButtonDetail),
  CategoryList: FastFieldWrapper(CategoryList),
  SelectionSearch: FastFieldWrapper(SelectionSearch),
  SelectCenter: FastFieldWrapper(SelectCenter),
  Button: FastFieldWrapper(Button),
  StarSelect: FastFieldWrapper(StarSelect),
  InputTag: FieldWrapper(InputTag),
  TooltipWrapper: FastFieldWrapper(TooltipWrapper),
  GallerySinglePicker: FastFieldWrapper(GallerySinglePicker),
  ErrorText: FastFieldWrapper(ErrorText),
  DateTimeInput: FastFieldWrapper(DateTimeInput),
  DiscountInput: FastFieldWrapper(DiscountInput),
  AmountWUnitInput: FastFieldWrapper(AmountWUnitInput),
}

export default {
  Field,
  FastField,
  Select,
}
